import API from "../helpers/interceptor";

export const addNewRole = async (role) => {
  return await API.post("/role/update", role);
};

export async function getAllRoles() {
  return API.post("/role/getroles");
}

export async function getAllActiveRolesData() {
  return API.post("/role/getactiveroles");
}

export async function getRoleHistory(roleCode) {
  return API.post("/role/getrolehistory", { roleCode });
}

export const getAvailableMenus = async () => {
  return API.post("/role/getavailablemenus");
};
